<div
  class="notification-bubble notification-bubble--{{ color }} notification-bubble--{{ fill }} notification-bubble--{{ size }}"
  [ngClass]="{ 'notification-bubble--disabled': disabled }"
>
  <span class="notification-bubble__label">{{ label }}</span>
</div>
